<template>
  <router-view></router-view>
</template>

<script>
import '../assets/js/bootstrap-year-calendar.js'

$.fn.calendar.dates['fr'] = {
	days: ["Dimanche", "Lundi", "Mardi", "Mercredi", "Jeudi", "Vendredi", "Samedi", "Dimanche"],
	daysShort: ["Dim", "Lun", "Mar", "Mer", "Jeu", "Ven", "Sam", "Dim"],
	daysMin: ["Di", "Lu", "Ma", "Me", "Je", "Ve", "Sa", "Di"],
	months: ["Janvier", "Février", "Mars", "Avril", "Mai", "Juin", "Juillet", "Août", "Septembre", "Octobre", "Novembre", "Décembre"],
	monthsShort: ["Jan", "Fév", "Mar", "Avr", "Mai", "Jui", "Jul", "Aou", "Sep", "Oct", "Nov", "Déc"],
	weekShort:'S',
	weekStart: 1
};

google.maps.Polygon.prototype.getBounds = function() {
	var bounds = new google.maps.LatLngBounds();
	var paths = this.getPaths();
	var path;        
	for (var i = 0; i < paths.getLength(); i++) {
    path = paths.getAt(i);
    for (var ii = 0; ii < path.getLength(); ii++) {
      bounds.extend(path.getAt(ii));
    }
	}
	return bounds;
}

import moment from 'moment'
export default {
	watch: {
		'$i18n.locale' (locale) {
			moment.locale(locale);
		}
	}
};
</script>


// WEBPACK FOOTER //
// App.vue?28efb41d